import * as React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import CommentLists from "components/molecules/List/CommentLists";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import IosShareIcon from "@mui/icons-material/IosShare";

const Body = styled(Box)(({ theme }) => ({
  backgroundColor: "#3E3C4C",
  display: "flex",
  flexDirection: "column",
  padding: "10px",
  borderRadius: "10px",
}));

const MainContent = styled(Box)(({ theme }) => ({
  paddingBottom: "10px",
}));

const FooterContent = styled(Box)(({ theme }) => ({
  display: "flex",
  paddingLeft: "50px",
  alignItems: "center",
}));


interface announcementCardProps {
  isDev: boolean;
  name: string;
}

const AnnouncementCard: React.FC<announcementCardProps> = ({ isDev, name }) => {
  return (
    <Body>
      <MainContent>
        <CommentLists
          isBig={true}
          isDev={isDev}
          name={name}
          announcement={
            "A special Christmas  NFTcollection will be added tomorrow! #Christmas"
          }
        />
      </MainContent>
      <FooterContent>
        <FavoriteBorderIcon
          style={{ color: "#c1c1c1", fontSize: "15px", paddingRight: "5px" }}
        />
        <Typography
          style={{ color: "#c1c1c1", fontSize: "11px", paddingRight: "10px" }}
        >
          13
        </Typography>
        <IosShareIcon style={{ color: "#c1c1c1", fontSize: "15px" }} />
      </FooterContent>
    </Body>
  );
};

export default AnnouncementCard;
